import request from '../http/index';
import { API_ROOT, API_AUTH, Api } from '../constants/ApiConfig';

const API = {
  Code() {
    return request(`${API_AUTH}${Api.Code}/1615777562209`, {
      method: 'get',
    });
  },
  Login(data) {
    return request(`${API_AUTH}${Api.Login}?vendorCode=${data.vendorCode}`, {
      method: 'post',
      data,
    });
  },
  Logout() {
    return request(`${API_ROOT}/sys/users/logout`, {
      method: 'post',
    });
  },
  updateAvatar(data) {
    return request(`${API_ROOT}/sys/users/updateAvatar`, {
      method: 'post',
      data,
    });
  },
  menusList(data) {
    return request(`${API_ROOT}${Api.Menus}/list`, {
      method: 'get',
      params: data,
    });
  },
  menusTree(data) {
    return request(`${API_ROOT}${Api.MenusTree}`, {
      method: 'get',
      params: data,
    });
  },
  menusBuild(data) {
    return request(`${API_ROOT}${Api.MenusBuild}`, {
      method: 'get',
      params: data,
    });
  },
  menusAdd(data) {
    return request(`${API_ROOT}${Api.Menus}`, {
      method: 'post',
      data,
    });
  },
  menusUpdate(id, data) {
    return request(`${API_ROOT}${Api.Menus}/${id}`, {
      method: 'put',
      data,
    });
  },
  menusDel(id) {
    return request(`${API_ROOT}${Api.Menus}/${id}`, {
      method: 'delete',
    });
  },
  dictionary() {
    return request(`${API_ROOT}/sys/dict/tree`, {
      method: 'get',
    });
  },
  accountsList(data) {
    return request(`${API_ROOT}${Api.Account}?organId=1&storeId=1`, {
      method: 'get',
      params: data,
    });
  },
  accountsAdd(data) {
    return request(`${API_ROOT}${Api.Account}`, {
      method: 'post',
      data,
    });
  },
  accountsUpdate(id, data) {
    return request(`${API_ROOT}${Api.Account}/${id}`, {
      method: 'put',
      data,
    });
  },
  accountsDel(id) {
    return request(`${API_ROOT}${Api.Account}/${id}`, {
      method: 'delete',
    });
  },
  accountsInfo() {
    return request(`${API_ROOT}/sys/users/info`, {
      method: 'get',
    });
  },
  accountsEnable(id) {
    return request(`${API_ROOT}/sys/users/${id}/enable`, {
      method: 'post',
    });
  },
  accountsDisable(id) {
    return request(`${API_ROOT}/sys/users/${id}/disable`, {
      method: 'post',
    });
  },
  permissionsList(data) {
    return request(`${API_ROOT}${Api.Permissions}`, {
      method: 'get',
      params: data,
    });
  },
  permissionsTree() {
    return request(`${API_ROOT}${Api.PermissionsTree}`, {
      method: 'get',
    });
  },
  permissionsAdd(data) {
    return request(`${API_ROOT}${Api.Permissions}`, {
      method: 'post',
      data,
    });
  },
  permissionsUpdate(id, data) {
    return request(`${API_ROOT}${Api.Permissions}/${id}`, {
      method: 'put',
      data,
    });
  },
  permissionsDel(id) {
    return request(`${API_ROOT}${Api.Permissions}/${id}`, {
      method: 'delete',
    });
  },
  rolesList(data) {
    return request(`${API_ROOT}${Api.Roles}`, {
      method: 'get',
      params: data,
    });
  },
  rolesTree(data) {
    return request(`${API_ROOT}${Api.RolesTree}`, {
      method: 'get',
      params: data,
    });
  },
  rolesAllList(data) {
    return request(`${API_ROOT}${Api.Roles}`, {
      method: 'get',
      params: data,
    });
  },
  rolesAdd(data) {
    return request(`${API_ROOT}${Api.Roles}`, {
      method: 'post',
      data,
    });
  },
  rolesUpdate(id, data) {
    return request(`${API_ROOT}${Api.Roles}/${id}`, {
      method: 'put',
      data,
    });
  },
  rolesMenuUpdate(id, data) {
    return request(`${API_ROOT}${Api.Roles}/${id}/menus/${data}`, {
      method: 'post',
    });
  },
  rolesPermissionUpdate(id, data) {
    return request(`${API_ROOT}${Api.Roles}/${id}/permission`, {
      method: 'put',
      data,
    });
  },
  rolesDel(id) {
    return request(`${API_ROOT}${Api.Roles}/${id}`, {
      method: 'delete',
    });
  },
  setPassword(data) {
    return request(`${API_ROOT}${Api.Password}`, {
      method: 'post',
      data,
    });
  },
  resetPassword(data) {
    return request(`${API_ROOT}/sys/users/resetPass`, {
      method: 'post',
      data,
    });
  },
  resourcesList(data) {
    return request(`${API_ROOT}${Api.Resources}`, {
      method: 'get',
      params: { ...data, from: 1 },
    });
  },

  resourcesEdit(data) {
    return request(`/mgmt/upload/file/update`, {
      method: 'post',
      data,
    });
  },

  uploadResource(data, configs) {
    return request(`${API_ROOT}/upload/file`, {
      method: 'post',
      data,
      ...configs,
    });
  },
  resourcesDel(id) {
    return request(`${API_ROOT}${Api.Resources}/${id}`, {
      method: 'delete',
    });
  },
  videoPreview(videoId, resourceId) {
    return request(`/mgmt/resources/${videoId}/preview/${resourceId}`, {
      method: 'post',
    });
  },
  videoPreviewUpdate(resourceId) {
    return request(`/mgmt/resources/${resourceId}`, {
      method: 'put',
    });
  },

  devicesList(data) {
    return request(`${API_ROOT}/devices`, {
      method: 'get',
      params: data,
    });
  },
  deviceLogList(data) {
    return request(`${API_ROOT}/devices/logs`, {
      method: 'get',
      params: data,
    });
  },
  deviceLogDownload(id) {
    return request(`${API_ROOT}/devices/logs/${id}/download`, {
      method: 'get',
      responseType: 'blob',
    });
  },
  deviceUsageList(data) {
    return request(`${API_ROOT}/devices/usage`, {
      method: 'get',
      params: data,
    });
  },
  getRealTimeData(sn, startTime) {
    return request(`${API_ROOT}/devices/${sn}/realtime`, {
      method: 'get',
      params: {startTime},
    });
  },
  getSummaryData(sn, startTime) {
    return request(`${API_ROOT}/devices/${sn}/summary`, {
      method: 'get',
      params: {startTime},
    });
  },
  devicesDel(mac) {
    return request(`${API_ROOT}/devices/${mac}`, {
      method: 'delete',
    });
  },
  batchDeleteDevices(data) {
    return request(`${API_ROOT}/devices/batch`, {
      method: 'delete',
      data: data,
    });
  },
  deviceDetailByMac(mac) {
    return request(`${API_ROOT}/devices/${mac}`, {
      method: 'get',
    });
  },
  devicesAdd(data) {
    return request(`${API_ROOT}/devices/register`, {
      method: 'post',
      data,
    });
  },
  devicesEdit(data) {
    return request(`${API_ROOT}/devices/update`, {
      method: 'post',
      data,
    });
  },
  devicesUpload(data) {
    return request(`${API_ROOT}/devices/import`, {
      method: 'post',
      data,
    });
  },
  devicesinformation(data) {
    return request(`${API_ROOT}/devices/usage`, {
      method: 'get',
      params: data,
    });
  },

  devicesSearch(data) {
    return request(`${API_ROOT}/devices`, {
      method: 'get',
      params: data,
    });
  },

  deviceModelAdd(data) {
    return request(`${API_ROOT}/device/models`, {
      method: 'post',
      data,
    });
  },
  deviceModelList(data) {
    return request(`${API_ROOT}/device/models`, {
      method: 'get',
      params: data,
    });
  },
  getDeviceModelByType(type) {
    return request(`${API_ROOT}/device/models/${type}/model`, {
      method: 'get',
    });
  },
  deviceModelEdit(id, data) {
    return request(`${API_ROOT}/device/models/${id}`, {
      method: 'put',
      data,
    });
  },
  deviceModelDel(id) {
    return request(`${API_ROOT}/device/models/${id}`, {
      method: 'delete',
    });
  },
  userList(data) {
    return request(`${API_ROOT}/users`, {
      method: 'get',
      params: data,
    });
  },
  userAddress(id, data) {
    return request(`${API_ROOT}/users/${id}`, {
      method: 'put',
      data,
    });
  },
  userDel(id) {
    return request(`${API_ROOT}/users/${id}`, {
      method: 'delete',
    });
  },
  userEnable(id) {
    return request(`${API_ROOT}/users/${id}/enable`, {
      method: 'post',
    });
  },
  userDisable(id) {
    return request(`${API_ROOT}/users/${id}/disable`, {
      method: 'post',
    });
  },
  softwareAdd(data) {
    return request(`${API_ROOT}/update`, {
      method: 'post',
      data,
    });
  },
  softwareList(data) {
    return request(`${API_ROOT}/update/list`, {
      method: 'get',
      params: data,
    });
  },
  softwareEdit(id, data) {
    return request(`${API_ROOT}/update/${id}`, {
      method: 'put',
      data,
    });
  },
  softwareDel(id) {
    return request(`${API_ROOT}/update/${id}`, {
      method: 'delete',
    });
  },
  batchDeleteSoftware(ids) {
    return request(`${API_ROOT}/update/batch`, {
      method: 'delete',
      params: ids,
    });
  },
  updateByStatistics(id) {
    return request(`${API_ROOT}/update/${id}/statistics`, {
      method: 'get',
    });
  },
  updateByDaily(id, data) {
    return request(`${API_ROOT}/update/${id}/daily`, {
      method: 'get',
      params: data,
    });
  },
  updateByMac(id, data) {
    return request(`${API_ROOT}/update/${id}/mac`, {
      method: 'get',
      params: data,
    });
  },
  updateByMacEdit(id, data) {
    return request(`${API_ROOT}/update/${id}/mac`, {
      method: 'post',
      data,
    });
  },
  updateByModel(id, data) {
    return request(`${API_ROOT}/update/${id}/model`, {
      method: 'get',
      params: data,
    });
  },
  updateByModelEdit(id, data) {
    return request(`${API_ROOT}/update/${id}/model`, {
      method: 'post',
      data,
    });
  },
  updateStatus(id, status) {
    return request(`${API_ROOT}/update/${id}/switch/${status}`, {
      method: 'post',
    });
  },

  configAdd(data) {
    return request(`${API_ROOT}/config`, {
      method: 'post',
      data,
    });
  },
  configList(data) {
    return request(`${API_ROOT}/config`, {
      method: 'get',
      params: data,
    });
  },
  configEdit(id, data) {
    return request(`${API_ROOT}/config/${id}`, {
      method: 'put',
      data,
    });
  },
  configDel(id) {
    return request(`${API_ROOT}/config/${id}`, {
      method: 'delete',
    });
  },
  reportList(data) {
    return request(`${API_ROOT}/users/report`, {
      method: 'get',
      params: data,
    });
  },
  reportAction(data) {
    return request(`${API_ROOT}/users/report/handle`, {
      method: 'post',
      data,
    });
  },
  // 分页获取字典分类
  getPageData(params) {
    return request(`${API_ROOT}/sys/dict`, {
      method: 'get',
      params,
    });
  },
  // 新增
  addDict(data) {
    return request(`${API_ROOT}/sys/dict`, {
      method: 'post',
      data,
    });
  },
  // 修改
  editDict(id, data) {
    return request(`${API_ROOT}/sys/dict/${id}`, {
      method: 'put',
      data,
    });
  },

  // 切换状态
  toggleStatus({ id, enable }) {
    return request(`${API_ROOT}/sys/dict/switch/${id}/${enable}`, {
      method: 'put',
    });
  },

  // 删除
  deleteDict({ id }) {
    return request(`${API_ROOT}/sys/dict/${id}`, {
      method: 'delete',
    });
  },

  // 新增二级
  addDictdetail({ label, dictId, value }) {
    return request(`${API_ROOT}/sys/dict/data`, {
      method: 'post',
      data: {
        label,
        dictId,
        value,
      },
    });
  },

  // 新增字典关联
  addDictRelate(data) {
    return request(`${API_ROOT}/sys/dict/data`, {
      method: 'post',
      data,
    });
  },

  // 某个字典的下级详情
  detailDict({ id }) {
    return request(`${API_ROOT}/sys/dict/data?dictId=${id}`, {
      method: 'get',
    });
  },
  // 某个字典的下级详情
  deleteDetail({ id }) {
    return request(`${API_ROOT}/sys/dict/data/${id}`, {
      method: 'delete',
    });
  },
  // 某个字典的下级详情
  editDictDetail(id, data) {
    return request(`${API_ROOT}/sys/dict/data/${id}`, {
      method: 'put',
      data,
    });
  },
  //根据字典类型查询字典值
  getDictDetail(dictType) {
    return request(`${API_ROOT}/sys/dict/data/dictType/${dictType}`, {
      method: 'get',
    });
  }, 

  //区域管理接口
  getdistrictList() {
    return request(`${API_ROOT}/organ/orgTree`, {
      method: 'get',
    });
  }, 
  getOrganPage(data) {
    return request(`${API_ROOT}/organ/organList`, {
      method: 'get',
      params: data
    });
  }, 
  createdistrict(data) {
    return request(`${API_ROOT}/organ/saveOrg`, {
      method: 'post',
      data,
    });
  },
  getstoreList() {
    return request(`${API_ROOT}/organ/orgStoreTree`, {
      method: 'post',
    });
  },
  getdistricttId(id) {
    return request(`${API_ROOT}/organ/toOrganUp?id=${id}`, {
      method: 'post',
    });
  },
  getOrganList() {
    return request(`${API_ROOT}/organ/orgList`, {
      method: 'post',
    });
  },


  getAgencyList() {
    return request(`${API_ROOT}/agency`, {
      method: 'get',
    });
  },
  getAgencyListByParentId(parentId) {
    return request(`${API_ROOT}/agency/${parentId}`, {
      method: 'get',
    });
  },
  createAgency(data) {
    return request(`${API_ROOT}/agency`, {
      method: 'post',
      params: data,
    });
  },
  updateAgency(data) {
    return request(`${API_ROOT}/organ/updateOrg`, {
      method: 'post',
      data,
    });
  },
  deleteOrgan(data) {
    return request(`${API_ROOT}/organ/deleteOrg`, {
      method: 'get',
      params: data
    });
  },

  // 门店保存
  createStore(data) {
    return request(`${API_ROOT}/store/save`, {
      method: 'post',
      data,
    });
  },
  updateStore(data) {
    return request(`${API_ROOT}/store/update`, {
      method: 'POST',
      data,
    });
  },
  deleteStore(data) {
    return request(`${API_ROOT}/store/delete`, {
      method: 'POST',
      data,
    });
  },
  getStoreId(id) {
    return request(`${API_ROOT}/store/storeList?organId=${id}`, {
      method: 'get',
    });
  },
  getStoreList(id) {
    return request(`${API_ROOT}/store/getStoreList?organId=${id}`, {
      method: 'get',
    });
  },
  // 员工管理
  staffList(data) {
    return request(`${API_ROOT}${Api.Account}/sys/users`, {
      method: 'get',
      params: data,
    });
  },
  staffLgetist(data) {
    return request(`${API_ROOT}/organ/orgStoreTree`, {
      method: 'post',
      params: data,
    });
  },
  getStaffListId(pid,id) {
    return request(`${API_ROOT}/sys/users?organId=${pid}&storeId=${id}`, {
      method: 'get',
    });
  },
  getStaffCreateId(data) {
    return request(`${API_ROOT}/sys/users`, {
      method: 'post',
      data,
    });
  },
  updateStaff(id,data) {
    return request(`${API_ROOT}/sys/users/${id}`, {
      method: 'put',
      data,
    });
  },
  staffLDel(id) {
    return request(`${API_ROOT}/sys/users/${id}`, {
      method: 'delete',
    });
  },
};
export default API;
